import axios from 'axios'

const clearAuthStorage = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem('id');
  localStorage.removeItem('name');
  localStorage.removeItem('email');
  localStorage.removeItem('role');
  localStorage.removeItem('ReadinessIndexType');
  localStorage.removeItem('SelectedFilter');
}

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle errors, including connection errors
    if (error?.response?.status === 401) {
      clearAuthStorage();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
      return Promise.reject(error);
    }
    if (error.message === 'Network Error' && error.code === 'ECONNREFUSED') {
      // Retry the request after a delay
      // return retryRequest(error.config);
      window.location.reload()
    }
    return Promise.reject(error);
  }
);

class APIService {

  baseURL

  constructor(baseURL) {
    this.baseURL = baseURL
  }

  setAccessToken(token) {
    localStorage.setItem("accessToken", token);
  }

  getAccessToken() {
    return localStorage.getItem("accessToken");
  }

  purgeAccessToken() {
    localStorage.removeItem("accessToken");
  }

  getHeaders() {
    return {
      Authorization: `Bearer ${this.getAccessToken()}`,
    };
  }

  get(url, config = {}) {
    return axios({
      method: "get",
      url: this.baseURL + url,
      headers: this.getAccessToken() ? this.getHeaders() : {},
      ...config,
    });
  }

  post(url, data = {}, config = {}) {
    return axios({
      method: "post",
      url: this.baseURL + url,
      data,
      headers: this.getAccessToken() ? this.getHeaders() : {},
      ...config,
    });
  }

  put(url, data = {}, config = {}) {
    return axios({
      method: "put",
      url: this.baseURL + url,
      data,
      headers: this.getAccessToken() ? this.getHeaders() : {},
      ...config,
    });
  }

  request(config = {}) {
    return axios(config);
  }
}

export default APIService
